import React from "react";

function Footer() {
  return (
    <footer>
      <div className="footer__top">
        <img src="/assets/img/logo.svg" alt="logo" />
        <ul>
          <li>
            <a href="#">Абитуриентам</a>
          </li>
          <li>
            <a href="#">Институт</a>
          </li>
          <li>
            <a href="#">Исследования</a>
          </li>
          <li>
            <a href="#">Студенческая жизнь </a>
          </li>
          <li>
            <a href="#">Новости</a>
          </li>
          <li>
            <a href="#">O нас</a>
          </li>
        </ul>
      </div>
      <div className="footer__bottom">
        <div className="item">
          <div className="footer__row">
            <img src="/assets/img/phone.svg" alt />
            <p>номер</p>
          </div>
          <p>
            {" "}
            <a href="tel: +998 (71) 2564504"> +998 71 256 45 04</a>
          </p>
        </div>
        <div className="item">
          <div className="footer__row">
            <img src="/assets/img/location.svg" alt />
            <p>Адрес</p>
          </div>
          <p>
            {" "}
            Тошкент ш. <br /> Ойбек кочаси 45 
          </p>
        </div>
        <div className="item">
          <div className="footer__row">
            <img src="/assets/img/email.svg" alt />
            <p>почта</p>
          </div>
          <p>info@pharmi.uz</p>
        </div>
        <div className="item">
          <div className="social">
            <div className="a">
              <a href="#">
                <img src="/assets/img/facebook.svg" alt />
              </a>
            </div>
            <div className="a">
              <a href="#">
                <img src="/assets/img/telegram.svg" alt />
              </a>
            </div>
            <div className="a">
              <a href="#">
                <img src="/assets/img/twitter.svg" alt />
              </a>
            </div>
            <div className="a">
              <a href="#">
                <img src="/assets/img/instagram.svg" alt />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
